<template>
  <v-tooltip right justify="end">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon small color="orange" v-if="validated === null">
        <v-icon>mdi-account-clock-outline</v-icon>
      </v-btn>
      <v-btn v-bind="attrs" v-on="on" icon small color="green" v-if="validated === true">
        <v-icon>mdi-account-check-outline</v-icon>
      </v-btn>
      <v-btn v-bind="attrs" v-on="on" icon small color="red" v-if="validated === false">
        <v-icon>mdi-account-cancel-outline</v-icon>
      </v-btn>
    </template>
    <span v-if="validated === null">Demande en cours de validation</span>
    <span v-if="validated === true">Demande validée</span>
    <span v-if="validated === false">Demande rejetée</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["validated"]
};
</script>